import { trustedBy } from "@/lib/home-content";
import InfiniteMarquee from "@/components/InfiniteMarquee";

const labelClass = "whitespace-nowrap font-display text-xl font-bold text-[#2B50FF] sm:text-2xl";
const nameClass = "whitespace-nowrap font-display text-xl font-bold text-[#b9b9c4] sm:text-2xl";

export default function TrustedBy() {
    const mid = Math.floor(trustedBy.logos.length / 2);
    const halves = [trustedBy.logos.slice(0, mid), trustedBy.logos.slice(mid)];

    return (
        <section className="bg-white px-0 py-5 sm:py-6">
            <div className="relative overflow-hidden">
                <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent" />
                <InfiniteMarquee groupClassName="gap-10 pr-10" duration={72}>
                    {halves.map((names) => (
                        <span key={names[0]} className="contents">
                            <span className={labelClass}>{trustedBy.label}</span>
                            {names.map((name) => (
                                <span key={name} className={nameClass}>
                                    {name}
                                </span>
                            ))}
                        </span>
                    ))}
                </InfiniteMarquee>
            </div>
        </section>
    );
}
